window.addEventListener('load', () => {
  if (window.Shopify.customerPrivacy?.userCanBeTracked()) {
    /* GOOGLE TAG MANAGER */
    // const shop = Shopify.shop?.split('.myshopify.com')[0];
    // switch (shop) {
    //   case 'apm-hk': // UK
    //     var container = 'GTM-MDHWG5P';
    //   case 'apm-mc': // US
    //     var container = 'GTM-MDHWG5P';
    //   case 'apm-fr': // FR
    //     var container = 'GTM-MSGBQVZ';
    //   case 'apm-uk': // INT
    //     var container = 'GTM-MDHWG5P';
    //   default:
    //     var container = 'GTM-MDHWG5P';
    // }
  
    /* GOOGLE ADWORDS */
    // window.dataLayer = window.dataLayer || [];
    // function gtag(){dataLayer.push(arguments);}
    // gtag('js', new Date());
    // gtag('config', 'AW-308770936');
  
    /* HOTJAR */
    (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:2539240,hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
  }
});

/* LIVE CHAT */
(function(u,t,d){
    var i=d.createElement(t);i.type='text/javascript';i.async=true;i.src='//'+u;
    var s=d.getElementsByTagName(t)[0]; s.parentNode.insertBefore(i,s);
})('asia2-track.inside-graph.com/gtm/IN-1000872-US/include.js','script',document);

/* SPLITIT */
(function(i,s,o,g,r,a,m){i['SplititObject']=r;i[r]=i[r]||function(){
  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window, document, 'script', '//upstream.production.splitit.com/v1/dist/upstream-messaging.js?v=1', 'splitit');
splitit('init', { apiKey:  '8706c514-1720-49f4-afbd-551f4c3c9273', lang: 'en-US', currency: 'GBP', currencySymbol: '£', debug: false });

/* Line */
(function(g,d,o){
  g._ltq=g._ltq||[];g._lt=g._lt||function(){g._ltq.push(arguments)};
  var h=location.protocol==='https:'?'https://d.line-scdn.net':'http://d.line-cdn.net';
  var s=d.createElement('script');s.async=1;
  s.src=o||h+'/n/line_tag/public/release/v1/lt.js';
  var t=d.getElementsByTagName('script')[0];t.parentNode.insertBefore(s,t);
    })(window, document);
_lt('init', {
  customerType: 'lap',
  tagId: '7ebd06ce-4734-4359-8800-84bdbb0bef01'
});
_lt('send', 'pv', ['7ebd06ce-4734-4359-8800-84bdbb0bef01']);


// Reload AfterShip Personalization after AJAX pagination
document.addEventListener('facet:update', function() {
  // Use requestAnimationFrame to ensure DOM is fully updated
  requestAnimationFrame(function() {
    if (window.AfterShipPersonalization && typeof window.AfterShipPersonalization.reload === 'function') {
      window.AfterShipPersonalization.reload();
    }
  });
});

function isThailandCart(cart) {
  return window.Shopify?.country === 'TH' || cart?.currency === 'THB';
}

function formatThailandTaxAmount(cents) {
  const amount = cents * 7 / 107 / 100;
  return amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) + ' \u0E3F';
}

function updateCartDrawerTaxLine(cart) {
  const drawer = document.getElementById('cart-drawer');
  const footer = drawer?.querySelector('.cart-drawer__footer');
  if (!footer || !cart || cart.item_count === 0 || !isThailandCart(cart)) {
    return;
  }

  const taxAmount = formatThailandTaxAmount(cart.total_price);
  const label = (window.themeVariables?.settings?.thailandTaxLabel || 'Total includes 7% VAT: @@').replace('@@', taxAmount);
  let taxLine = footer.querySelector('.cart-tax-included');

  if (!taxLine) {
    taxLine = document.createElement('p');
    taxLine.className = 'text-subdued text-sm cart-tax-included cart-tax-included--centered';
    footer.querySelector('.button-group')?.before(taxLine);
  }

  taxLine.textContent = label;
}

document.addEventListener('cart:change', (event) => {
  const cart = event.detail?.cart;
  if (!cart) return;
  requestAnimationFrame(() => updateCartDrawerTaxLine(cart));
});

document.addEventListener('cart:refresh', () => {
  fetch(`${window.Shopify.routes.root}cart.js`)
    .then((response) => response.json())
    .then((cart) => requestAnimationFrame(() => updateCartDrawerTaxLine(cart)));
});

window.addEventListener('load', () => {
  fetch(`${window.Shopify.routes.root}cart.js`)
    .then((response) => response.json())
    .then((cart) => updateCartDrawerTaxLine(cart));
});


function isSouthKoreaStorefront() {
  return window.Shopify?.country === 'KR' || window.Shopify?.currency?.active === 'KRW';
}

function formatKoreaWonText(text) {
  if (!text || !/[₩￦]|KRW/i.test(text)) return null;

  const next = text
    .replace(/[₩￦]\s*([\d][\d,]*(?:\.\d+)?)\s*(?:원|KRW)?/g, '$1원')
    .replace(/\bKRW\s*([\d][\d,]*(?:\.\d+)?)/gi, '$1원')
    .replace(/([\d][\d,]*(?:\.\d+)?)\s*KRW\b/gi, '$1원')
    .replace(/([\d])\s+원/g, '$1원')
    .replace(/\s{2,}/g, ' ')
    .replace(/원\s*원/g, '원');

  return next === text ? null : next;
}

function reformatKoreaPrices(root = document) {
  if (!isSouthKoreaStorefront() || !root.querySelectorAll) return;

  const containers = root.matches?.('product-recommendations, recently-viewed-products, [data-personalization-id], .shopify-section--related-products, .shopify-section--complementary-products, .complementary-products')
    ? [root]
    : root.querySelectorAll('product-recommendations, recently-viewed-products, [data-personalization-id], .shopify-section--related-products, .shopify-section--complementary-products, .complementary-products');

  containers.forEach((container) => {
    container.querySelectorAll('*').forEach((el) => {
      if (el.children.length > 0) return;
      if (!/^\s*[₩￦]\s*$|^\s*KRW\s*$/i.test(el.textContent || '')) return;

      const amountEl = el.nextElementSibling;
      if (amountEl && /\d/.test(amountEl.textContent || '') && !amountEl.textContent.includes('원')) {
        amountEl.textContent = `${amountEl.textContent.trim()}원`;
        el.textContent = '';
      }
    });

    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || parent.closest('script, style, noscript, textarea, input')) {
          return NodeFilter.FILTER_REJECT;
        }
        if (!node.nodeValue || !/[₩￦]|KRW/i.test(node.nodeValue)) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    const updates = [];
    let node;
    while ((node = walker.nextNode())) {
      const next = formatKoreaWonText(node.nodeValue);
      if (next) updates.push([node, next]);
    }
    updates.forEach(([textNode, next]) => {
      textNode.nodeValue = next;
    });
  });
}

function watchKoreaRecommendationPrices() {
  if (!isSouthKoreaStorefront()) return;

  reformatKoreaPrices();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        reformatKoreaPrices(node);
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener('facet:update', () => {
  requestAnimationFrame(() => reformatKoreaPrices());
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', watchKoreaRecommendationPrices);
} else {
  watchKoreaRecommendationPrices();
}


const ACCOUNT_DOT_STORAGE_KEY = 'apm.headerAccountDotDismissed';

function dismissAccountDot() {
  try {
    window.localStorage.setItem(ACCOUNT_DOT_STORAGE_KEY, '1');
  } catch (e) {}
  document.documentElement.classList.add('account-dot-dismissed');
}

document.addEventListener('click', (event) => {
  const accountLink = event.target.closest?.('a');
  if (!accountLink?.querySelector('.header__account-dot')) return;
  dismissAccountDot();
});

/* Replay the Clear filters hover wipe on touch before the facet update */
(() => {
  const WIPE_MS = 450;
  const touchQuery = window.matchMedia('(hover: none), (pointer: coarse)');

  document.addEventListener(
    'click',
    (event) => {
      if (!touchQuery.matches) return;

      const link = event.target.closest('a.facets-clear-all');
      if (!link || link.dataset.clearWipeReady === '1') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      link.classList.add('is-wiping');

      window.setTimeout(() => {
        link.dataset.clearWipeReady = '1';
        link.click();
      }, WIPE_MS);
    },
    true
  );
})();